import { DateInput } from "@/components/common/DateInput";

interface DateRangeInputProps {
  key?: string;
  minDate?: string | Date | null;
  maxDate?: string | Date | null;
  includeTime?: boolean;
  format24?: boolean;
  placeholder?: string;
  value: { start?: string; end?: string } | undefined;
  group?:
    | "down"
    | "down-left"
    | "down-right"
    | "left"
    | "right"
    | "up"
    | "up-left"
    | "up-right"
    | "single"
    | "middle"
    | "middle-right"
    | "middle-left"
    | "middle-up";
  onChange: (value: { start: string; end: string }) => void;
  onBlur: () => void;
}
export const DateRangeInput = ({
  value,
  format24,
  includeTime,
  maxDate,
  minDate,
  placeholder,
  key,
  onChange,
  onBlur,
  group,
}: DateRangeInputProps) => {
  return (
    <div className="flex flex-col w-full gap-2">
      <DateInput
        className="h-11"
        key={`${key}-start`}
        minDate={minDate}
        maxDate={maxDate}
        includeTime={includeTime ?? false}
        format24={format24 ?? false}
        placeholder={placeholder || "Seleccione una fecha"}
        value={value?.start || ""}
        onChange={(date) => {
          onChange({
            start: date,
            end: value?.end || "",
          });
          onBlur();
        }}
        group={group}
      />
      <DateInput
        key={`${key}-end`}
        minDate={minDate}
        maxDate={maxDate}
        includeTime={includeTime ?? false}
        format24={format24 ?? false}
        placeholder={placeholder || "Seleccione una fecha"}
        value={value?.end || ""}
        onChange={(date) => {
          onChange({
            start: value?.start || "",
            end: date,
          });
          onBlur();
        }}
      />
    </div>
  );
};
